var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconEstateFeature3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 30c0-2.76 2.24-5 5-5s5 2.24 5 5M30 23v5",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 30C1 13.98 13.98 1 30 1s29 12.98 29 29",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 30c0-16.02 8-29 19-29s19 12.98 19 29",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M23 30c0-16.02 2-29 7-29s7 12.98 7 29M11 30c0-3.31 2.69-6 6-6s6 2.69 6 6M37 30c0-3.31 2.69-6 6-6s6 2.69 6 6M49 30c0-2.76 2.24-5 5-5s5 2.24 5 5",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M23 30c0-3.87 3.13-7 7-7s7 3.13 7 7",
  stroke: "#999",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M26 45c0 2.21 1.79 4 4 4s4-1.79 4-4-4-4-4-4-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4",
  stroke: "#B18D3B",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

export default SvgIconEstateFeature3;